import { useSelector } from "react-redux";
import { State } from "../../../store";
import { SaleStep, StepSaleConfig } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import { getLocalizedStepText } from "../../../store/stepSaleConfig/stepSaleConfigUtils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ComponentList } from "../../../models/ComponentList";

/* eslint-disable import/no-anonymous-default-export */
export default () => {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const customOffers = useSelector((state: State) => state.stepSaleConfig.customOffers);
  const offerId = new URLSearchParams(window.location.search).get("offerId");
  const saleStepIdParam = new URLSearchParams(window.location.search).get("saleStepId");

  const [customOffer, setCustomOffer] = useState<StepSaleConfig | null>(null);
  const [customOfferLinks, setCustomOfferLinks] = useState<ComponentList[]>([]);

  const getOfferByOfferId = () => {
    const offer = customOffers.find((offer) => offer.stepId === offerId);
    setCustomOffer(offer || null);
  };

  useEffect(() => {
    getOfferByOfferId();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offerId, customOffers]);

  useEffect(() => {
    const links = customOffers
      .map((offer) => ({
        id: offer.stepId,
        name: getLocalizedStepText(offer.stepName, offer.stepName_en, language),
        active: offer.showInNavbar,
        order: offer.order,
      }))
      .sort((a, b) => a.order - b.order);
    setCustomOfferLinks(links);
  }, [customOffers, language]);

  const getSaleStepByStepId = (): SaleStep | null => {
    const steps = customOffers;
    if (!saleStepIdParam) {
      return null;
    }

    for (const step of steps) {
      const foundSaleStep = step.saleSteps.find((saleStep) => saleStep.id === saleStepIdParam);
      if (foundSaleStep) {
        return foundSaleStep;
      }
    }
    return null;
  };

  const getCurrentCustomOfferLink = () => {
    if (customOffer) {
      return {
        id: customOffer.stepId,
        name: getLocalizedStepText(customOffer.stepName, customOffer.stepName_en, language),
        active: true,
        order: customOffer.order,
      };
    } else {
      return null;
    }
  };

  return { customOffer, customOfferLinks, getSaleStepByStepId, getCurrentCustomOfferLink };
};
